import PropTypes from 'prop-types'
import React, { Component } from 'react'
import MarkDetails from './MarkDetails'
import MarkForm from './MarkForm'
import I18n from 'i18n'

export default class MarkRow extends Component {
  static propTypes = {
    onCancel: PropTypes.func,
    handleClick: PropTypes.func.isRequired,
    mark: PropTypes.object,
    onDelete: PropTypes.func,
    onSave: PropTypes.func.isRequired,
    videoLength: PropTypes.number.isRequired
  }

  static defaultProps = {
    mark: {}
  }

  state = {
    editing: false
  }

  handleEditClick = () => {
    this.setState({ editing: true })
  }

  handleCancel = () => {
    this.setState({ editing: false })
    const { onCancel } = this.props
    if (onCancel) {
      onCancel()
    }
  }

  handleSave = mark => {
    this.props
      .onSave(mark)
      .then(() => this.setState({ editing: false }))
      .catch(() => {
        /* do nothing */
      })
  }

  handleDelete = mark => {
    const message = I18n.t('Are you sure you wish to delete this mark?')
    if (window.confirm(message)) {
      this.props.onDelete(mark)
    }
  }

  render() {
    const { editing } = this.state
    const { mark, handleClick, videoLength } = this.props
    if (editing || !mark.id) {
      return (
        <MarkForm
          key={mark.id || 'new-mark'}
          mark={mark}
          onCancelClick={this.handleCancel}
          onSave={this.handleSave}
          videoLength={videoLength}
        />
      )
    }

    return (
      <div>
        <MarkDetails
          key={mark.id}
          mark={mark}
          handleClick={handleClick}
          onEditClick={this.handleEditClick}
          onDelete={this.handleDelete}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/MarkRow.js